import Vue from 'vue'
import VueResource from 'vue-resource'
import router from '../router'
import urlApi from '../router/urlApi'
import Vuex from 'vuex'
import store from '../store'
Vue.use(Vuex)
Vue.use(VueResource)
let optionsToast = {
  theme: 'none',
  position: 'top-left',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  fullWidth: false,
  duration: 3000,
  icon: 'fa-warning'
}
export class Auth {
  static autenticate () {
    return Vue.http.get(urlApi + '/login/autenticate')
  }

  static login (dados) {
    localStorage.clear();
    return Vue.http.post(urlApi + '/login', dados)
      .then((response) => {
        console.log(response)
        window.localStorage['usuario']  = JSON.stringify(response.data.usuario)
        window.localStorage['token'] = response.data.access_token
        window.localStorage['refresh_token'] = response.data.refresh_token
        window.localStorage['id_role'] = response.data.id_role
        window.localStorage['role'] = response.data.role
        window.localStorage['schema'] = response.data.schema
        window.localStorage['cfc'] = response.data.cfc
        window.localStorage['url'] = response.data.url
        window.localStorage['email'] = response.data.email
        window.localStorage['nome_fantasia'] = response.data.nome_fantasia
        window.localStorage['gratuidade_teorica'] = response.data.gratuidade_teorica
        window.localStorage['gratuidade_pratica'] = response.data.gratuidade_pratica
        window.localStorage['permissions'] = JSON.stringify(response.data.role.permissions)
        store.commit('authenticated')

        if (response.data.role.id_funcao_usuario == 2) {
          router.push({ name: 'DashboardMonitoramento' })
        } else if (response.data.role.id_funcao_usuario == 6) {
          router.push({ name: 'faturas_boletos' })
        } else if (response.data.role.id_funcao_usuario == 7) {
          router.push({ name: 'EnvioAulasPraticas' })
        } else if (response.data.role.id_funcao_usuario == 8) {
          router.push({ name: 'lista-autoescolas' })
        } else if (response.data.role.id_funcao_usuario == 9) {
          router.push({ name: 'Getran-listarAlunos' })
        } else {
          router.push({ name: 'dashboard' })
        }

      }).catch((response) => {
        console.log(response)
        Vue.toasted.show(response.data.mensagem, optionsToast)
        router.push({ name: 'login' })
      })
  }

  static loginAluno (dados) {
    document.getElementById('btn_login').innerHTML = 'Aguarde...'
    document.getElementById('btn_login').disabled = true
    localStorage.clear();
    return Vue.http.post(urlApi + '/login/aluno', dados)
      .then((response) => {
        console.log(response)
        document.getElementById('btn_login').innerHTML = 'LOGIN'
        document.getElementById('btn_login').disabled = false
        window.localStorage['usuario']  = JSON.stringify(response.data.usuario)
        window.localStorage['aluno'] = JSON.stringify(response.data.aluno)
        window.localStorage['token'] = response.data.access_token
        window.localStorage['refresh_token'] = response.data.refresh_token
        window.localStorage['id_role'] = response.data.id_role
        window.localStorage['role'] = response.data.role
        window.localStorage['schema'] = response.data.schema
        window.localStorage['cfc'] = response.data.cfc
        window.localStorage['url'] = response.data.url
        window.localStorage['id'] = response.data.aluno.id_aluno
        window.localStorage['cpf'] = response.data.aluno.cpf
        window.localStorage['nome'] = response.data.aluno.nome
        window.localStorage['tipo_processo'] = response.data.aluno.tipo_processo
        window.localStorage['nome_fantasia'] = response.data.nome_fantasia
        window.localStorage['permissions'] = JSON.stringify(response.data.role.permissions)
        store.commit('authenticated')
        router.push({ name: 'aulas-teoricas' })
      }).catch((response) => {
        console.log(response)
        Vue.toasted.show(response.data.dados, optionsToast)
        document.getElementById('btn_login').innerHTML = 'LOGIN'
        document.getElementById('btn_login').disabled = false
        router.push({ name: 'loginAluno' })
      })
  }

  static loginInstrutor (dados) {
    document.getElementById('btn_login').innerHTML = 'Aguarde...'
    document.getElementById('btn_login').disabled = true
    localStorage.clear();
    return Vue.http.post(urlApi + '/login/instrutor', dados)
      .then((response) => {
        console.log(response)
        document.getElementById('btn_login').innerHTML = 'LOGIN'
        document.getElementById('btn_login').disabled = false
        window.localStorage['usuario']  = JSON.stringify(response.data.usuario)
        window.localStorage['token'] = response.data.access_token
        window.localStorage['refresh_token'] = response.data.refresh_token
        window.localStorage['id_role'] = response.data.id_role
        window.localStorage['role'] = response.data.role
        window.localStorage['schema'] = response.data.schema
        window.localStorage['cfc'] = response.data.cfc
        window.localStorage['url'] = response.data.url
        window.localStorage['id'] = response.data.instrutor.id_instrutor
        window.localStorage['cpf'] = response.data.instrutor.cpf
        window.localStorage['nome'] = response.data.instrutor.nome
        window.localStorage['nome_fantasia'] = response.data.nome_fantasia
        window.localStorage['permissions'] = JSON.stringify(response.data.role.permissions)
        store.commit('authenticated')
        // router.push({ name: 'listagem-turmas' })
        router.push({ name: 'aulasInstrutor' })
      }).catch((response) => {
        console.log(response)
        Vue.toasted.show(response.data.mensagem, optionsToast)
        document.getElementById('btn_login').innerHTML = 'LOGIN'
        document.getElementById('btn_login').disabled = false
        router.push({ name: 'loginInstrutor' })
      })
  }

  static logout () {
    var autoescola = ''
    if (window.localStorage.schema !== 'public') {
      autoescola = window.localStorage.schema
    }
    return Vue.http.post(urlApi + '/login/logout')
      .then(() => {
        router.push({ name: 'login', params: { autoescola: autoescola } })
        store.commit('unauthenticated', autoescola)
        localStorage.clear();
      }).catch(() => {
        router.push({ name: 'login', params: { autoescola: autoescola } })
        store.commit('unauthenticated', autoescola)
        localStorage.clear();
      })
  }

  static logoutAluno () {
    var autoescola = ''
    if (window.localStorage.schema !== 'public') {
      autoescola = window.localStorage.schema
    }
    return Vue.http.post(urlApi + '/login/logout')
      .then(() => {
        router.push({ name: 'loginAluno', params: { autoescola: autoescola } })
        store.commit('unauthenticated', autoescola)
        localStorage.clear();
      }).catch(() => {
        router.push({ name: 'loginAluno', params: { autoescola: autoescola } })
        store.commit('unauthenticated', autoescola)
        localStorage.clear();
      })
  }

  static logoutInstrutor () {
    var autoescola = ''
    if (window.localStorage.schema !== 'public') {
      autoescola = window.localStorage.schema
    }
    return Vue.http.post(urlApi + '/login/logout')
      .then(() => {
        router.push({ name: 'loginInstrutor' })
        store.commit('unauthenticated', autoescola)
        localStorage.clear();
      }).catch(() => {
        router.push({ name: 'loginInstrutor' })
        store.commit('unauthenticated', autoescola)
        localStorage.clear();
      })
  }

  static refreshToken () {
    let dados = { refresh_token: window.localStorage['refresh_token'] }
    return Vue.http.post(urlApi + '/login/refresh-token', dados)
  }

  static resetPassword (dados) {
    document.getElementById('btn_redefinir_email').innerHTML = 'AGUARDE'
    document.getElementById('btn_redefinir_email').disabled = true
    return Vue.http.post(urlApi + '/login/reset-password', dados)
      .then((response) => {
        document.getElementById('btn_redefinir_email').innerHTML = 'ENVIAR'
        document.getElementById('btn_redefinir_email').disabled = false
        Vue.toasted.show(response.data.mensagem, optionsToast)
        router.push({ name: 'login' })
      }).catch((response) => {
        document.getElementById('btn_redefinir_email').innerHTML = 'ENVIAR'
        document.getElementById('btn_redefinir_email').disabled = false
        if (response.status === 422) {
          Object.keys(response.data.errors).forEach(function (key) {
            Vue.toasted.show(response.data.errors[key][0], optionsToast)
          })
        } else {
          Vue.toasted.show('Erro não identificado!', optionsToast)
        }
      })
  }

  static changePassword (dados) {
    document.getElementById('btn_nova_senha').innerHTML = 'AGUARDE'
    document.getElementById('btn_nova_senha').disabled = true
    return Vue.http.patch(urlApi + '/login/reset-password', dados)
      .then((response) => {
        document.getElementById('btn_nova_senha').innerHTML = 'REDEFINIR'
        document.getElementById('btn_nova_senha').disabled = false
        Vue.toasted.show(response.data.mensagem, optionsToast)
        router.push({ name: 'login' })
      }).catch((response) => {
        document.getElementById('btn_nova_senha').innerHTML = 'REDEFINIR'
        document.getElementById('btn_nova_senha').disabled = false
        if (response.status === 422) {
          Object.keys(response.data.errors).forEach(function (key) {
            Vue.toasted.show(response.data.errors[key][0], optionsToast)
          })
        } else {
          Vue.toasted.show('Erro não identificado!', optionsToast)
        }
      })
  }
}
